var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preset.app)?_c('div',{},[(_vm.preset.app && _vm.preset.app.app_footer)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.preset.app.app_footer)}}):_c('div',[_vm._v(" Copyright © 2021. "+_vm._s(_vm.$organization.org_name)+". ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }